var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 2,
    fill: "#1A1B1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.30149C6 6.13581 6.13431 6.00149 6.3 6.00149L17.7 6.00149C17.8657 6.00149 18 6.13581 18 6.30149L18 7.78594C18 7.95162 17.8657 8.08594 17.7 8.08594L6.3 8.08594C6.13431 8.08594 6 7.95162 6 7.78594L6 6.30149Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.60618C6 9.4405 6.13431 9.30618 6.3 9.30618L17.7 9.30618C17.8657 9.30618 18 9.4405 18 9.60618L18 11.0906C18 11.2563 17.8657 11.3906 17.7 11.3906L6.3 11.3906C6.13431 11.3906 6 11.2563 6 11.0906L6 9.60618Z",
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12.9109C6 12.7452 6.13431 12.6109 6.3 12.6109L17.7 12.6109C17.8657 12.6109 18 12.7452 18 12.9109L18 14.3953C18 14.561 17.8657 14.6953 17.7 14.6953L6.3 14.6953C6.13431 14.6953 6 14.561 6 14.3953L6 12.9109Z",
    fill: "#1A1B1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16.2156C6 16.0499 6.13431 15.9156 6.3 15.9156L17.7 15.9156C17.8657 15.9156 18 16.0499 18 16.2156L18 17.7C18 17.8657 17.8657 18 17.7 18L6.3 18C6.13431 18 6 17.8657 6 17.7L6 16.2156Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.bafe1be0a92288074a7a8643cc81cb6e.svg";
export { ForwardRef as ReactComponent };